import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import config from 'config';
import Section from 'components/Section';
import { Divider, Paper } from '@material-ui/core';

const ForResearcher = () => {
  // scroll to top when entering page view
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <>
      <Helmet>
        <title>Tutkijalle | {config.site.name}</title>
      </Helmet>
      <Section className="section--page">
        <Paper elevation={2}>
          <div className="page-wrapper">
            <h1 className="page-title">
              Tutkijalle{' '}
            </h1>
            <Divider />
            <p>
              {' '}
              Lakitutkasta kerättyjen aineistojen käyttäjän
              on noudatettava Tutkimuseettisen
              neuvottelukunnan (TENK) ohjeita{' '}
              <a
                href="https://tenk.fi/fi/ohjeet-ja-aineistot/HTK-ohje-2012"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                "Hyvä tieteellinen käytäntö ja sen
                loukkausepäilyjen käsitteleminen Suomessa"
              </a>
              .
            </p>
            <p>
              Jos haluat käyttää Lakitutkaa aineiston
              keräämiseen, muttet löytänyt etsimääsi tai et
              onnistunut keräämään aineistoa toivotulla
              tavalla, ole meihin yhteydessä{' '}
              <a href="mailto:lakitutka@utu.fi">
                lakitutka@utu.fi
              </a>
              .
            </p>
            <h2 className="page-subtitle">
              Viittausohjeet
            </h2>
            <p>
              Kun hyödynnät Lakitutkaa esimerkiksi
              tutkimuksessa, tulee julkaisun metodiosiossa
              mainita, että tutkimuksessa on käytetty Turun
              yliopiston Lakitutkaa. Aineistoluetteloon
              tulee sisällyttää yleinen maininta siitä, että
              Lakitutkaa on käytetty aineiston
              keräämiseen/rajaamiseen/muuhun vastaavaan.
              Jokaisen Lakitutkalla kerätyn asiakirjan
              kohdalla ei kuitenkaan tarvitse viitata
              erikseen Lakitutkaan. Viittaa Lakitutkaan
              aineistoluettelossa näin: Tutkimusaineiston
              keräämiseen/rajaamiseen/analysointiin/… on
              käytetty Turun yliopiston{' '}
              <a
                href="https://lakitutka.fi/"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                Lakitutka-palvelua
              </a>
              .
            </p>{' '}
            <p>
              DOI:{' '}
              <a
                href="https://zenodo.org/record/6504432"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                10.5281/zenodo.6504432
              </a>
            </p>{' '}
          </div>
        </Paper>
      </Section>
    </>
  );
};

export default ForResearcher;
